import { Card, Container, Grid, Paper, Skeleton, Stack } from '@mui/material';

const PERSONAL_DATA_FIELDS = 8;

export default function ProfileSkeleton() {
  return (
    <Container maxWidth="lg">
      <Stack direction="row" spacing={1.5} sx={{ mb: 5 }}>
        {Array.from({ length: 5 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Skeleton key={index} variant="rounded" width={110} height={36} />
        ))}
      </Stack>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ py: 10, px: 3, textAlign: 'center' }}>
            <Skeleton variant="circular" width={144} height={144} sx={{ mx: 'auto' }} />
            <Skeleton variant="text" width="60%" sx={{ mx: 'auto', mt: 3 }} />
          </Card>
        </Grid>

        <Grid item xs={12} md={8}>
          <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
            <Skeleton variant="rounded" width={120} height={32} />
            <Skeleton variant="rounded" width={120} height={32} />
          </Stack>

          <Card sx={{ p: 2 }}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Stack gap={2}>
                <Skeleton variant="text" width={140} />
                <Grid container spacing={2}>
                  {Array.from({ length: PERSONAL_DATA_FIELDS }).map((_, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                    >
                      <Skeleton variant="rounded" width="100%" height={56} />
                    </Grid>
                  ))}
                </Grid>
              </Stack>
            </Paper>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
